import moment from "moment"
import { api } from "./apiConfig"

export const buildQueryParams = (
  selectedMonth: string,
  page: number,
  count: number,
  isPast: boolean,
  locale: string,
) => {
  let startDate, endDate;
  moment.locale(locale);
  let queryParams = "isPast=false&";
  if (selectedMonth === "" && isPast) {
    startDate = moment().subtract(1, "year").startOf("day").format("YYYY-MM-DD");
    endDate = moment().endOf("day").format("YYYY-MM-DD");
    queryParams = `isPast=true&startDate=${startDate}&endDate=${endDate}`;
  }

  if (selectedMonth !== "" && isPast) {
    const startDate = moment(selectedMonth, "MMMM YYYY")
      .startOf("month")
      .format("YYYY-MM-DD");

    const endDate = moment(selectedMonth, "MMMM YYYY")
      .endOf("month")
      .format("YYYY-MM-DD");

    queryParams += `isPast=true&startDate=${startDate}&endDate=${endDate}`;
  }

  if (selectedMonth === "" && !isPast) {
    queryParams = `isPast=false&startDate=${moment().startOf("day").format("YYYY-MM-DD")}&endDate=${moment().add(1, "year").format("YYYY-MM-DD")}`;
  }

  if (selectedMonth !== "" && !isPast) {
    const startDate = moment(selectedMonth, "MMMM YYYY")
      .startOf("month")
      .format("YYYY-MM-DD");

    const endDate = moment(selectedMonth, "MMMM YYYY")
      .endOf("month")
      .format("YYYY-MM-DD");

    queryParams += `isPast=true&startDate=${startDate}&endDate=${endDate}`;
  }
  return queryParams
}

export async function getReservations(queryParams: string) {
  try {
    const response = await api.get(
      `/Reservations/GetAllAccountReservations?${queryParams}`,
    )

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function cancelReservation(reservationId: string, projectId: string) {
  try {
    let response = await api.delete(
      `/Reservations/${reservationId}/${projectId}/Cancelv2`, { data: {} },
    );

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

